// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DateOutlinedSvg from "@fishx/icons-svg/es/asn/DateOutlined";
import FishxIcon from '../components/FishxIcon';

var DateOutlined = function DateOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DateOutlinedSvg
  }));
};

DateOutlined.displayName = 'DateOutlined';
export default React.forwardRef(DateOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DateOutlined.js
// module id = 2388
// module chunks = 0